var _path, _ellipse, _path2, _path3, _rect, _circle, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinClub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 80,
    viewBox: "0 0 55 80",
    color: "#484848",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1562 26.4039C54.1562 40.9864 27.1562 80 27.1562 80C27.1562 80 0.15625 40.9864 0.15625 26.4039C0.15625 11.8214 12.2446 0 27.1562 0C42.0679 0 54.1562 11.8214 54.1562 26.4039Z",
    fill: "currentColor"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.7531,
    cy: 26.0099,
    rx: 18.5373,
    ry: 18.1281,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6795 19.0233C23.9445 20.4426 24.2216 20.8504 24.8906 21.0734C25.3638 21.2311 26.3132 21.3174 27.0985 21.3888C28.8332 21.5465 29.0413 21.5465 29.9876 21.5465C29.8298 20.8106 29.5144 19.3071 29.5144 19.181C29.5144 19.0233 29.0413 17.6039 30.1453 17.4462C31.2492 17.2885 31.7223 18.2348 31.88 18.7079C32.0377 19.181 33.2489 22.4927 32.6181 23.1235C31.9315 23.8101 30.6184 23.912 25.8873 23.7543C21.1562 23.5966 21.1562 19.6697 21.1562 18.8656V18.8653C21.1563 18.0767 21.1563 16.5 22.4179 16.5C23.5218 16.5 23.5058 18.0931 23.6795 19.0233Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9296 33.2506C28.5191 33.2492 27.3433 30.9884 27.1563 29.9538L28.6562 27.0001L30.2005 30.3169L31.683 28.7668C32.0925 28.3722 33.1226 27.8654 33.7285 28.5571C34.2542 29.1574 34.1082 29.7706 33.981 29.9539C33.2183 31.0533 31.3401 33.2519 29.9296 33.2506Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.6289,
    y: 21.5464,
    width: 5.36188,
    height: 9.14674,
    rx: 2.68094,
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.7831,
    cy: 19.0233,
    r: 1.89243,
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7845 27.9271C23.9631 27.139 24.7469 26.6448 25.535 26.8234C26.341 27.006 26.8359 27.8193 26.6278 28.619L25.7806 31.875C25.7248 32.0894 25.6871 32.308 25.668 32.5287L25.42 35.3858C25.344 36.2624 24.5115 36.8703 23.6533 36.6758C22.9276 36.5113 22.4438 35.8247 22.5331 35.086L22.9576 31.5764L23.7845 27.9271Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinClub);
export default __webpack_public_path__ + "static/media/pin-club.1cac4edcf916c4e0ff00e267e3b18285.svg";
export { ForwardRef as ReactComponent };